import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { widgetTypes } from '../model';

const { persistAtom } = recoilPersist();
export const registeredBiometriesState = atom<widgetTypes[]>({
  key: 'registeredBiometriesState',
  default: [],
  effects_UNSTABLE: [persistAtom],
});
